import { AccordionItemProps } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { SpAccordionHeader } from 'routes/essential-workspace/components/quote-panel/collapse/accordion-header';
import { Quote } from 'routes/essential-workspace/components/quote-panel/quote';

import { CollapseKey } from './types';

type QuoteCollapseItemProps = Omit<AccordionItemProps, 'eventKey'> & {
  eventKey: CollapseKey;
  isSummary?: boolean;
};

export function QuoteAccordionItem({ isSummary = false, eventKey, ...props }: QuoteCollapseItemProps) {
  return (
    <Accordion.Item {...props} eventKey={eventKey} className="border-0 p-0">
      <Quote isBordered>
        <SpAccordionHeader withoutArrow>
          {isSummary ? (
            <Quote.Summary className="px-4 py-3" />
          ) : (
            <Quote.Header>
              <Quote.Modes />
              <Quote.Badge />
            </Quote.Header>
          )}
        </SpAccordionHeader>

        <Accordion.Collapse eventKey={eventKey}>
          <div className="flex-y gap-4 p-4">
            <Quote.Details />
            <Quote.Actions />
          </div>
        </Accordion.Collapse>
      </Quote>
    </Accordion.Item>
  );
}
